jQuery('body').on('click', 'section.popup a#button-continue, section.popup div.close', function (event) {
	jQuery.get('/shoppingcart/refresh/', function(result) {
		jQuery('section.span3.e-commerce-list').html(result.html);
	},'json');
});